

 




<mat-tab-group (selectedTabChange)="onSocieteTabChange($event)">
  
<mat-tab label=" {{'languages.prospect.particulier' | translate}}">
    <!-- Keep your existing contrat table here -->
    <div class="flex-column bg-white rounded-card">
      <div class="p-3 mb-3">
      <div class="flex-column bg-white rounded-card">
  <div class="p-3 mb-3">

    <!-- ✅ Loading Spinner -->
    <div *ngIf="show_loading_add" class="spinner-style d-flex justify-content-center align-items-center">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>

    <!-- ✅ Search and Generate Button -->
<div class="d-flex justify-content-between align-items-center mb-2">

 
  <div class="dataTables_length d-flex align-items-center" id="ticketsTable_length">
    <label class="d-flex align-items-center mb-0">
      <span class="me-2">Afficher&nbsp; </span>
      <select
       [(ngModel)]="pageSize" aria-controls="contratTable"
        class="custom-select custom-select-sm form-control form-control-sm me-2"
      >
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      &nbsp;éléments
    </label>
  </div>

  <!-- RIGHT : Search + Button -->
  <div class="d-flex align-items-center gap-2">
       <div class="d-flex me-3">
            <mat-spinner class="mr-4 mt-1" [diameter]="25" *ngIf="loaderInfo" ></mat-spinner>
           <button id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false"  type="button"
               class="add-btn-searchOpp" >
               
               <i class="fa-solid fa-magnifying-glass fa fa-lg fa-flip-horizontal"></i>
               &nbsp;
                {{'languages.buttons.rechercherPar' | translate}}

           </button>
     
     <div class="dropdown-menu popup dropdown-menu-right"
     aria-labelledby="dropdownMenuButton"
     [ngClass]="{'hidden': !isDropdownVisible}"
     data-bs-auto-close="outside"> <!-- prevent auto close -->
     
  <div class="popup-content" (click)="stopClickPropagation($event)">

              
                <div class="row mt-1"
                    *ngFor="let form of formInfoHolder ;let index = index; let isFirst = first;">
                
                    <div class="input-group  col-10">
                        <select class="custom-select"  name="key{{index}}" id="key{{index}}" [(ngModel)]="formInfoHolder[index].key"   (ngModelChange)="setValues(index , 'key', $event)" >
                            <option [disabled]="item.disabled" value="{{item.name}}" *ngFor="let item of listkeys">{{item.title}}</option>
                        </select>
                            
                        <input type="text" aria-label="Last name"
                            placeholder="{{'languages.prospect.enterValue' | translate}}" class="form-control "  name="val{{index}}" id="val{{index}}"
                            (change)="setValues(index , 'value', $event)"  />
                    </div>
                    <div class="col-2  d-flex align-items-center justify-content-start " *ngIf="isFirst">
                        <button type="button" class="btn-dt-add "
                            (click)="onAdd()">
                            <i class="fa-solid fa-plus fa-lg"></i>
                        </button>
                    </div>
                    <div class="col-2  d-flex align-items-center justify-content-start" *ngIf="!isFirst">
                        <button type="button" class=" cancelBtn float-left"
                            (click)="deletePrspect(index)">
                            <img src="assets/icons/closeIcon.svg" class="iconClose">
                        </button>
                    </div>
                </div>
              

                <div class="row w-100 d-flex justify-content-center mt-4">
                    <div class=" mx-2  text-right ">
                        <button (click)=" onSearch($event.target.value)" class=" btn-dt-save-popup"  data-toggle="modal" data-target="#listProspect" type="button">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                            {{'languages.buttons.rechercher' | translate}}
                        </button>
                        
                    </div>
                    <div class=" mx-2 text-right ">
                        <button class="btn-dt-cancel-popup" style="width:128px" type="button" (click)="clearModal('')">
<i class="fa-solid fa-circle-xmark fa-lg mr-1"></i>
                                {{'languages.buttons.annuler' | translate}}
                        </button>
                    </div>
            
                </div>
            </div>
        </div>
    </div>
   
  <button type="button" class="btn-keygen" *ngIf="listContrats?.length > 0"
      (click)="generatePdf(listData)" id="keygen">
                                    <i class="fa-solid fa-key fa-lg"></i>
                                     {{'languages.user.generate' | translate}}
                                </button>
  
  </div>

</div>


    <!-- ✅ Contracts Table -->
    <table class="table" id="contratTable">
      <thead class="head-table">
        <tr>
          <th>{{ "languages.affaire.nContrat" | translate }}</th>
          <th>{{ "languages.affaire.solde" | translate }}</th>
          <th>{{ "languages.affaire.compagnie" | translate }}</th>
          <th>{{ "languages.affaire.ligneproduit" | translate }}</th>
          <th>{{ "languages.listing.Statut" | translate }}</th>
          <th>{{ "languages.listing.Affaire" | translate }}</th>
          <th></th> <!-- Expand column -->
        </tr>
      </thead>

      <tbody class="body-table">
        <!-- ✅ No Data -->
        <tr *ngIf="!show_loading_add && (!listContrats || listContrats.length === 0)">
          <td colspan="7" class="text-center py-4">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
                <g clip-path="url(#clip0_1805_13925)">
                  <path d="M15.4954 0C14.2758 0 13.2905 0.996855 13.2905 2.23073V3.56916C8.2606 4.60087 4.47095 9.10415 4.47095 14.4997V15.8103C4.47095 19.0866 3.27894 22.2515 1.12917 24.7053L0.619293 25.2839C0.0405103 25.9392 -0.0972952 26.8802 0.254109 27.6819C0.605512 28.4836 1.39789 28.9994 2.26607 28.9994H28.7247C29.5929 28.9994 30.3784 28.4836 30.7367 27.6819C31.095 26.8802 30.9503 25.9392 30.3715 25.2839L29.8616 24.7053C27.7118 22.2515 26.5198 19.0936 26.5198 15.8103V14.4997C26.5198 9.10415 22.7302 4.60087 17.7003 3.56916V2.23073C17.7003 0.996855 16.715 0 15.4954 0ZM18.6167 34.388C19.4435 33.5515 19.9052 32.4152 19.9052 31.2302H15.4954H11.0856C11.0856 32.4152 11.5473 33.5515 12.3741 34.388C13.2009 35.2245 14.324 35.6916 15.4954 35.6916C16.6667 35.6916 17.7898 35.2245 18.6167 34.388Z" fill="#959494"/>
                </g>
                <defs>
                  <clipPath id="clip0_1805_13925">
                    <rect width="30.8684" height="35.6916" fill="white" transform="translate(0.0625)"/>
                  </clipPath>
                </defs>
              </svg>
              <p class="noData mb-0">
                {{ 'languages.miniListing.emptyTable' | translate }}
              </p>
            </div>
          </td>
        </tr>

        <!-- ✅ Data Rows -->
        <ng-container *ngFor="let item of paginatedContrats; let i = index">
          <tr>
            <td>{{ item.num_contrat }}</td>
            <td>{{ item.montant }}</td>
            <td>{{ item.cmp }}</td>
            <td>{{ item.risque }}</td>
            <td>
              <div class="btn-status d-flex justify-content-center"
                   [style.background]="item.color"
                   [style.color]="item.couleur_police">
                {{ item.etat }}
              </div>
            </td>
            <td>
              <a *ngIf="item.id_affaire" target="_blank" [href]="'/affaires/details/' + item.id_affaire">
                <i class="fa-solid fa-link fa-icon-style"></i>
                {{ "languages.listing.Affaire" | translate }}
              </a>
              <div *ngIf="!item.id_affaire">-</div>
            </td>
            <td>
              <button mat-icon-button aria-label="expand row" (click)="toggleExpand(item)" *ngIf="item.list_contrats_fils?.length > 0">
                <mat-icon>
                  {{ expandedElement === item ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </mat-icon>
              </button>
            </td>
          </tr>

          <!-- Expanded child content -->
          <tr *ngIf="expandedElement === item" class="expand-row">
            <td colspan="7" class="p-0">

              <!-- ✅ Case: children exist -->
              <table *ngIf="item.list_contrats_fils?.length > 0; else noChildren" 
                     class="table table-sm mb-0 child-table">
                <thead>
                  <tr>
                    <th>{{ "languages.affaire.nContrat" | translate }}</th>
                   <th>{{ "languages.affaire.solde" | translate }}</th>
          <th>{{ "languages.affaire.compagnie" | translate }}</th>
          <th>{{ "languages.affaire.ligneproduit" | translate }}</th>
                    <th>{{ "languages.listing.Statut" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let child of item.list_contrats_fils">
                    <td>{{ child.num_contrat }}</td>
                    <td>{{ child.montant }}</td>
                    <td>{{ child.cmp }}</td>
                    <td>{{ child.risque }}</td>
                    <td>
                      <div class="btn-status d-flex justify-content-center"
                           [style.background]="child.color"
                           [style.color]="child.couleur_police">
                        {{ child.etat }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- ✅ Case: no children -->
              <ng-template #noChildren>
                <div class="p-2 text-center text-muted">
                  Aucun contrat fils
                </div>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

 
<!-- Page navigation (styled like DataTables) -->
  <div class="dataTables_paginate paging_simple_numbers">
    <div class="dataTables_info" role="status" aria-live="polite">
    Affichage de {{ (page - 1) * pageSize + 1 }}
    à {{ (page * pageSize) > totalItems ? totalItems : (page * pageSize) }}
    sur {{ totalItems }} éléments
  </div>

  <!-- Page navigation (right) -->
  <div class="dataTables_paginate paging_simple_numbers">
    <ul class="pagination mb-0">

      <!-- First -->
      <li class="paginate_button page-item" [class.disabled]="page === 1">
        <a class="page-link" (click)="page = 1" [class.disabled]="page === 1">
          <i class="fa fa-angle-double-left" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Previous -->
      <li class="paginate_button page-item" [class.disabled]="page === 1">
        <a class="page-link" (click)="page = page - 1" [class.disabled]="page === 1">
          <i class="fa fa-angle-left" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Current Page -->
      <li class="paginate_button page-item active">
        <a class="page-link">{{ page }}</a>
      </li>

      <!-- Next -->
      <li class="paginate_button page-item" [class.disabled]="page >= totalPages">
        <a class="page-link" (click)="page = page + 1" [class.disabled]="page >= totalPages">
          <i class="fa fa-angle-right" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Last -->
      <li class="paginate_button page-item" [class.disabled]="page >= totalPages">
        <a class="page-link" (click)="page = totalPages" [class.disabled]="page >= totalPages">
          <i class="fa fa-angle-double-right" style="color:#007bff"></i>
        </a>
      </li>
    </ul>
  </div>

  
  </div>
  </div>
</div>
      </div>
    </div>
  </mat-tab>

  <!-- 🔹 Dynamic Sociétés tabs -->
  <mat-tab *ngFor="let soc of listSociete" [label]="soc.RS">
    <div class="flex-column bg-white rounded-card">
      <div class="p-3 mb-3">

        <!-- Spinner while loading -->
        <div *ngIf="show_loading_add" class="d-flex justify-content-center align-items-center">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>

        <!-- Table for société contrats -->
      <!-- ✅ Same structure as Individuelle -->
<div *ngIf="!show_loading_add && societeContrats[soc.id]">

  <!-- Search + Page size + PDF -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <!-- Left: page size -->
    <div class="dataTables_length d-flex align-items-center">
      <label class="d-flex align-items-center mb-0">
        <span class="me-2">Afficher&nbsp;</span>
        <select [(ngModel)]="societePageSize[soc.id]"
        (ngModelChange)="onSocietePageSizeChange(soc.id, $event)"
        class="custom-select custom-select-sm form-control form-control-sm me-2">
  <option [value]="10">10</option>
  <option [value]="25">25</option>
  <option [value]="50">50</option>
  <option [value]="100">100</option>
</select>  &nbsp;éléments
      </label>
    </div>

    <!-- Right: Search + PDF -->
    <div class="d-flex align-items-center gap-2">
        <div class="d-flex me-3">
            <mat-spinner class="mr-4 mt-1" [diameter]="25" *ngIf="loaderInfo" ></mat-spinner>
           <button id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false"   type="button"
               class="add-btn-searchOpp" >
               
               <i class="fa-solid fa-magnifying-glass fa fa-lg fa-flip-horizontal"></i>
               &nbsp;
                {{'languages.buttons.rechercherPar' | translate}}

           </button>
     
     <div class="dropdown-menu popup dropdown-menu-right"
     aria-labelledby="dropdownMenuButton"
     [ngClass]="{'hidden': !isDropdownVisible}"
     data-bs-auto-close="outside"> <!-- prevent auto close -->
     
  <div class="popup-content" (click)="stopClickPropagation($event)">

              
                <div class="row mt-1"
                    *ngFor="let form of formInfoHolder ;let index = index; let isFirst = first;">
                
                    <div class="input-group  col-10">
                        <select class="custom-select"  name="key{{index}}" id="key{{index}}" [(ngModel)]="formInfoHolder[index].key"   (ngModelChange)="setValues(index , 'key', $event)" >
                            <option [disabled]="item.disabled" value="{{item.name}}" *ngFor="let item of listkeys">{{item.title}}</option>
                        </select>
                            
                        <input type="text" aria-label="Last name"
                            placeholder="{{'languages.prospect.enterValue' | translate}}" class="form-control "  name="val{{index}}" id="val{{index}}"
                            (change)="setValues(index , 'value', $event)"  />
                    </div>
                    <div class="col-2  d-flex align-items-center justify-content-start " *ngIf="isFirst">
                        <button type="button" class="btn-dt-add "
                            (click)="onAdd()">
                            <i class="fa-solid fa-plus fa-lg"></i>
                        </button>
                    </div>
                    <div class="col-2  d-flex align-items-center justify-content-start" *ngIf="!isFirst">
                        <button type="button" class=" cancelBtn float-left"
                            (click)="deletePrspect(index)">
                            <img src="assets/icons/closeIcon.svg" class="iconClose">
                        </button>
                    </div>
                </div>
              

                <div class="row w-100 d-flex justify-content-center mt-4">
                    <div class=" mx-2  text-right ">
                        <button (click)=" OnOpen(soc.id)" class=" btn-dt-save-popup"  data-toggle="modal" data-target="#listProspect" type="button">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                            {{'languages.buttons.rechercher' | translate}}
                        </button>
                        
                    </div>
                    <div class=" mx-2 text-right ">
                        <button class="btn-dt-cancel-popup" style="width:128px" type="button" (click)="clearModal(soc.id)">
<i class="fa-solid fa-circle-xmark fa-lg mr-1"></i>
                                {{'languages.buttons.annuler' | translate}}
                        </button>
                    </div>
            
                </div>
            </div>
        </div>
    </div>
     
      <button type="button" class="btn-keygen" *ngIf="societeContrats[soc.id]?.length > 0"
        (click)="generatePdf( listDataSociete)">
        <i class="fa-solid fa-key fa-lg"></i>
        {{ 'languages.user.generate' | translate }}
      </button>
    </div>
  </div>

  <!-- Table -->
  <table class="table">
    <thead class="head-table">
      <tr>
        <th>{{ "languages.affaire.nContrat" | translate }}</th>
       <th>{{ "languages.affaire.solde" | translate }}</th>
          <th>{{ "languages.affaire.compagnie" | translate }}</th>
          <th>{{ "languages.affaire.ligneproduit" | translate }}</th>
        <th>{{ "languages.listing.Statut" | translate }}</th>
        <th>{{ "languages.listing.Affaire" | translate }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody class="body-table">
         <!-- ✅ No Data -->
                  <tr *ngIf="!show_loading_add && (!societeContrats[soc.id] || societeContrats[soc.id].length === 0)">

          <td colspan="7" class="text-center py-4">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
                <g clip-path="url(#clip0_1805_13925)">
                  <path d="M15.4954 0C14.2758 0 13.2905 0.996855 13.2905 2.23073V3.56916C8.2606 4.60087 4.47095 9.10415 4.47095 14.4997V15.8103C4.47095 19.0866 3.27894 22.2515 1.12917 24.7053L0.619293 25.2839C0.0405103 25.9392 -0.0972952 26.8802 0.254109 27.6819C0.605512 28.4836 1.39789 28.9994 2.26607 28.9994H28.7247C29.5929 28.9994 30.3784 28.4836 30.7367 27.6819C31.095 26.8802 30.9503 25.9392 30.3715 25.2839L29.8616 24.7053C27.7118 22.2515 26.5198 19.0936 26.5198 15.8103V14.4997C26.5198 9.10415 22.7302 4.60087 17.7003 3.56916V2.23073C17.7003 0.996855 16.715 0 15.4954 0ZM18.6167 34.388C19.4435 33.5515 19.9052 32.4152 19.9052 31.2302H15.4954H11.0856C11.0856 32.4152 11.5473 33.5515 12.3741 34.388C13.2009 35.2245 14.324 35.6916 15.4954 35.6916C16.6667 35.6916 17.7898 35.2245 18.6167 34.388Z" fill="#959494"/>
                </g>
                <defs>
                  <clipPath id="clip0_1805_13925">
                    <rect width="30.8684" height="35.6916" fill="white" transform="translate(0.0625)"/>
                  </clipPath>
                </defs>
              </svg>
              <p class="noData mb-0">
                {{ 'languages.miniListing.emptyTable' | translate }}
              </p>
            </div>
          </td>
        </tr>
      <ng-container *ngFor="let item of getPaginatedSocieteContrats(soc.id)">
  <tr>
    <td>{{ item.num_contrat }}</td>
    <td>{{ item.montant }}</td>
    <td>{{ item.cmp }}</td>
    <td>{{ item.risque }}</td>
    <td>
      <div class="btn-status d-flex justify-content-center"
           [style.background]="item.color"
           [style.color]="item.couleur_police">
        {{ item.etat }}
      </div>
    </td>
    <td>
      <a *ngIf="item.id_affaire" target="_blank" [href]="'/affaires/details/' + item.id_affaire">
        <i class="fa-solid fa-link fa-icon-style"></i>
        {{ "languages.listing.Affaire" | translate }}
      </a>
      <div *ngIf="!item.id_affaire">-</div>
    </td>
    <td>
      <button mat-icon-button (click)="toggleExpand(item)" *ngIf="item.list_contrats_fils?.length > 0">
        <mat-icon>
          {{ expandedElement === item ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </button>
    </td>
  </tr>

  <!-- Expanded row -->
  <tr *ngIf="expandedElement === item" class="expand-row">
    <td colspan="7" class="p-0">
      <table *ngIf="item.list_contrats_fils?.length > 0; else noChildren"
             class="table table-sm mb-0 child-table">
        <thead>
          <tr>
            <th>{{ "languages.affaire.nContrat" | translate }}</th>
           <th>{{ "languages.affaire.solde" | translate }}</th>
          <th>{{ "languages.affaire.compagnie" | translate }}</th>
          <th>{{ "languages.affaire.ligneproduit" | translate }}</th>
            <th>{{ "languages.listing.Statut" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let child of item.list_contrats_fils">
            <td>{{ child.num_contrat }}</td>
            <td>{{ child.montant }}</td>
            <td>{{ child.cmp }}</td>
            <td>{{ child.risque }}</td>
            <td>
              <div class="btn-status d-flex justify-content-center"
                   [style.background]="child.color"
                   [style.color]="child.couleur_police">
                {{ child.etat }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #noChildren>
        <div class="p-2 text-center text-muted">Aucun contrat fils</div>
      </ng-template>
    </td>
  </tr>
</ng-container>

    </tbody>
  </table>

  <!-- Pagination -->
 <!-- Pagination -->
<!-- ✅ Société Pagination -->
<div class="dataTables_paginate paging_simple_numbers d-flex align-items-center mt-2">

  <!-- Info (gauche) -->
  <div class="dataTables_info me-auto" role="status" aria-live="polite">
    Affichage de {{ getSocieteStart(soc.id) }}
    à {{ getSocieteEnd(soc.id) }}
    sur {{ societeContrats[soc.id]?.length || 0 }} éléments
  </div>

  <!-- Controls (centre) -->
  <div class="pagination-container mx-auto">
    <ul class="pagination mb-0 justify-content-center">
      <!-- First -->
      <li class="paginate_button page-item" [class.disabled]="(societePage[soc.id] || 1) === 1">
        <a class="page-link" (click)="setSocietePage(soc.id, 1)">
          <i class="fa fa-angle-double-left" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Prev -->
      <li class="paginate_button page-item" [class.disabled]="(societePage[soc.id] || 1) === 1">
        <a class="page-link" (click)="prevSocietePage(soc.id)">
          <i class="fa fa-angle-left" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Current -->
      <li class="paginate_button page-item active">
        <a class="page-link">{{ societePage[soc.id] || 1 }}</a>
      </li>

      <!-- Next -->
      <li class="paginate_button page-item"
          [class.disabled]="(societePage[soc.id] || 1) >= getSocieteTotalPages(soc.id)">
        <a class="page-link" (click)="nextSocietePage(soc.id)">
          <i class="fa fa-angle-right" style="color:#007bff"></i>
        </a>
      </li>

      <!-- Last -->
      <li class="paginate_button page-item"
          [class.disabled]="(societePage[soc.id] || 1) >= getSocieteTotalPages(soc.id)">
        <a class="page-link" (click)="setSocietePage(soc.id, getSocieteTotalPages(soc.id))">
          <i class="fa fa-angle-double-right" style="color:#007bff"></i>
        </a>
      </li>
    </ul>
  </div>
</div>


</div>


    

      </div>
    </div>
  </mat-tab>

</mat-tab-group>
